import {
  Dropdown,
  LeadsListListData,
  leadsListListInfiniteOptions,
  // pportunitiesPipelinesListData,
  // opportunitiesPipelinesListListInfiniteOptions,
  OpportunitiesStatusesListData,
  opportunitiesStatusesListListInfiniteOptions,
  PaginatedDropdownList,
  TagsListData,
  tagsListListInfiniteOptions,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import {
  InfiniteSelect,
  // IsTenderSelect,
  RangePickerFilter
} from '@crm/components'
import { useRolePermission } from '@crm/hooks/useRolePermission'
import { UserRoleCRM } from '@crm/types'
import { defaultFiltersMultipleValues } from '@crm/utils'
import { MoreFiltersPopover } from '@shared/components'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { defaultFilters } from '@shared/utils'
import { Flex, InputNumber, Tooltip } from 'antd'
// import { useParams } from 'react-router-dom'

export const OpportunitiesFilter = () => {
  const { params, updateQuery } = useQueryUpdate()

  const { t } = useLocales()
  // const { id } = useParams()

  const hasPermissionMix = useRolePermission([
    UserRoleCRM.manager,
    UserRoleCRM.admin
  ])

  const filtersCount = [
    'created_at_gte',
    'value_under',
    'value_over',
    'is_tender',
    'tags'
  ].filter((filter) => params?.[filter])?.length

  const leadValue = defaultFiltersMultipleValues(params?.lead, true)
  // const pipelineValue = defaultFiltersMultipleValues(params?.pipeline, true)
  const statusValue = defaultFiltersMultipleValues(params?.status, true)
  const ownerValue = defaultFiltersMultipleValues(params?.owner)
  const tagsValue = defaultFiltersMultipleValues(params?.tags, true)

  const onUpdateFilter = (filter: string, value: string[]) => {
    updateQuery({ [filter]: value, page: defaultFilters.page })
  }

  const onResetMoreFilters = () =>
    updateQuery({
      created_at_gte: undefined,
      created_at_lte: undefined,
      value_under: undefined,
      value_over: undefined,
      product: undefined,
      tags: undefined,
      is_tender: undefined
    })

  return (
    <>
      <InfiniteSelect<LeadsListListData, PaginatedDropdownList, Dropdown>
        value={leadValue}
        className="select-min-width"
        popupMatchSelectWidth
        mode="multiple"
        placeholder={t('filter.leads')}
        getQueryFunction={leadsListListInfiniteOptions}
        onChange={(lead) => onUpdateFilter('lead', lead)}
        baseOptions={{
          query: { preference: params?.lead }
        }}
        maxTagCount={1}
        maxTagTextLength={6}
      />

      {/* {!id && (
        <InfiniteSelect<
          OpportunitiesPipelinesListData,
          PaginatedDropdownList,
          Dropdown
        >
          value={pipelineValue}
          className="select-min-width"
          popupMatchSelectWidth
          mode="multiple"
          placeholder={t('contacts.pipeline')}
          getQueryFunction={opportunitiesPipelinesListListInfiniteOptions}
          onChange={(value) => onUpdateFilter('pipeline', value)}
          baseOptions={{
            query: { preference: params?.pipeline }
          }}
          maxTagCount={1}
          maxTagTextLength={6}
        />
      )} */}

      <InfiniteSelect<
        OpportunitiesStatusesListData,
        PaginatedDropdownList,
        Dropdown
      >
        value={statusValue}
        className="select-min-width"
        popupMatchSelectWidth
        mode="multiple"
        placeholder={t('task.status')}
        getQueryFunction={opportunitiesStatusesListListInfiniteOptions}
        onChange={(value) => onUpdateFilter('status', value)}
        baseOptions={{
          query: { preference: params?.status }
        }}
        maxTagCount={1}
        maxTagTextLength={6}
      />

      {hasPermissionMix && (
        <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
          value={ownerValue}
          className="select-min-width"
          popupMatchSelectWidth
          placeholder={t('opportunities.responsible')}
          getQueryFunction={usersListListInfiniteOptions}
          onChange={(owner) => onUpdateFilter('owner', owner)}
          baseOptions={{
            query: { preference: params?.owner }
          }}
          mode="multiple"
          maxTagCount={1}
          maxTagTextLength={6}
        />
      )}

      <MoreFiltersPopover
        filterActiveCount={filtersCount}
        onResetMoreFilters={onResetMoreFilters}
      >
        <Tooltip title={t('opportunity.select_created_date_period')}>
          <RangePickerFilter
            fromParam="created_at_gte"
            toParam="created_at_lte"
            placeholder={[
              t('opportunity.created_at_from'),
              t('opportunity.created_at_to')
            ]}
          />
        </Tooltip>

        <Flex>
          <InputNumber
            value={params?.value_under}
            placeholder={t('opportunity.value_under')}
            onChange={(value) => onUpdateFilter('value_under', [value])}
          />
        </Flex>

        <Flex>
          <InputNumber
            value={params?.value_over}
            placeholder={t('opportunity.value_over')}
            onChange={(value) => onUpdateFilter('value_over', [value])}
          />
        </Flex>

        {/* <IsTenderSelect /> */}

        <InfiniteSelect<TagsListData, PaginatedDropdownList, Dropdown>
          placeholder={t('sales_funnel_report.tags')}
          getQueryFunction={tagsListListInfiniteOptions}
          onChange={(tags) => updateQuery({ tags })}
          baseOptions={{
            query: { preference: params?.tags }
          }}
          value={tagsValue}
          mode="multiple"
          className="w-full"
          maxTagCount={1}
          maxTagTextLength={6}
        />
      </MoreFiltersPopover>
    </>
  )
}
